import React from 'react';
import { SubTitle, Title } from './Title';
import * as styleSheet from '../styles';
import { Box, Image } from '@enaep-ng/benchmark';
import spinnerGif from '../img/spinner.gif';
import { WaitProps } from '../types';


function Wait(props: WaitProps) {
  const { title, subTitle, className, style } = props;

  return (
    <Box style={styleSheet.waitContainer} className={className} sx={style}>
      {title && <Title content={title} />}
      <Image
        style={{
          height: 'calc(220px * var(--zoom))',
        }}
        src={spinnerGif}
      />
      {subTitle && <SubTitle content={subTitle} />}
    </Box>
  );
}

export default Wait;
